import { GetterTree, MutationTree, ActionTree, ActionContext, Module } from 'vuex'
import axios, { AxiosResponse } from 'axios'
import Cookies from 'js-cookie'
import { RootState } from '@/store/types'
import { State, Getter, Mutation, Action } from './types'
import * as types from './types'
import settings from '@/settings'
import * as audioUtil from '@/utils/audio'
import { effects, userRecorded, bgm } from './effects'

// 音のプリセット
const presetScore: types.SoundOnScore[] = [
  // // 音の長さ確認用
  // { id: -100, soundId: 'train1', trackIndex: 0, when: 1.611 },
  // { id: -98, soundId: 'train2', trackIndex: 0, when: 1.611 * 3 },
  // { id: -97, soundId: 'train-door', trackIndex: 0, when: 1.611 * 4 },
  // { id: -96, soundId: 'train-running', trackIndex: 0, when: 1.611 * 5 },
  // { id: -95, soundId: 'call-for-departure', trackIndex: 0, when: 1.611 * 6 },
  // { id: -94, soundId: 'soon-ebina', trackIndex: 0, when: 1.611 * 7 },
  // { id: -93, soundId: 'crossing', trackIndex: 0, when: 1.611 * 9 },
  // { id: -92, soundId: 'robot', trackIndex: 0, when: 1.611 * 10 },
  // { id: -91, soundId: 'guitar', trackIndex: 0, when: 1.611 * 11 },
  // { id: -90, soundId: 'bass', trackIndex: 0, when: 1.611 * 12 },

  // // 音の長さ確認用
  // { id: -89, soundId: 'drum', trackIndex: 0, when: 1.611 },
  // { id: -88, soundId: 'piano', trackIndex: 0, when: 1.611 * 2 },
  // { id: -87, soundId: 'maracas', trackIndex: 0, when: 1.611 * 3 },
  // { id: -86, soundId: 'dog', trackIndex: 0, when: 1.611 * 4 },
  // { id: -85, soundId: 'cat', trackIndex: 0, when: 1.611 * 5 },
  // { id: -84, soundId: 'dj', trackIndex: 0, when: 1.611 * 6 },

  // // テスト再生
  // // IDはユニークになるようにマイナスから
  // { id: -19, soundId: 'soon-ebina', trackIndex: 0, when: 0.81245 },
  // { id: -18, soundId: 'call-for-departure', trackIndex: 0, when: 4.06225 },
  // { id: -17, soundId: 'train2', trackIndex: 1, when: 4.06225 },
  // { id: -16, soundId: 'cat', trackIndex: 0, when: 5.68715 },
  // { id: -15, soundId: 'dog', trackIndex: 1, when: 6.4996 },

  // // テンポごとに置いてみる
  // { id: -100, soundId: 'small-drum', trackIndex: 0, when: 0.81245 },
  // { id: -99, soundId: 'small-drum', trackIndex: 0, when: 1.6249 },
  // { id: -98, soundId: 'small-drum', trackIndex: 0, when: 2.43735 },
  // { id: -97, soundId: 'small-drum', trackIndex: 0, when: 3.2498 },
  // { id: -96, soundId: 'small-drum', trackIndex: 0, when: 4.06225 },
  // { id: -95, soundId: 'small-drum', trackIndex: 0, when: 4.8747 },
  // { id: -94, soundId: 'small-drum', trackIndex: 0, when: 5.68715 },
  // { id: -93, soundId: 'small-drum', trackIndex: 0, when: 6.4996 },
  // { id: -92, soundId: 'small-drum', trackIndex: 0, when: 7.31205 },
  // { id: -91, soundId: 'small-drum', trackIndex: 0, when: 8.1245 },
  // { id: -90, soundId: 'small-drum', trackIndex: 0, when: 8.93695 },
  // { id: -89, soundId: 'small-drum', trackIndex: 0, when: 9.7494 },
  // { id: -88, soundId: 'small-drum', trackIndex: 0, when: 10.56185 },
  // { id: -87, soundId: 'small-drum', trackIndex: 0, when: 11.3743 },
  // { id: -86, soundId: 'small-drum', trackIndex: 0, when: 12.18675 },
  // { id: -85, soundId: 'small-drum', trackIndex: 0, when: 12.9992 },
  // { id: -84, soundId: 'small-drum', trackIndex: 0, when: 13.81165 },
  // { id: -83, soundId: 'small-drum', trackIndex: 0, when: 14.6241 },
  // { id: -82, soundId: 'small-drum', trackIndex: 0, when: 15.43655 },
  // { id: -81, soundId: 'small-drum', trackIndex: 0, when: 16.249 },
  // { id: -80, soundId: 'small-drum', trackIndex: 0, when: 17.06145 },
  // { id: -79, soundId: 'small-drum', trackIndex: 0, when: 17.8739 },
  // { id: -78, soundId: 'small-drum', trackIndex: 0, when: 18.68635 },
  // { id: -77, soundId: 'small-drum', trackIndex: 0, when: 19.4988 },
  // { id: -76, soundId: 'small-drum', trackIndex: 0, when: 20.31125 },
  // { id: -75, soundId: 'small-drum', trackIndex: 0, when: 21.1237 },
  // { id: -74, soundId: 'small-drum', trackIndex: 0, when: 21.93615 },
  // { id: -73, soundId: 'small-drum', trackIndex: 0, when: 22.7486 },
  // { id: -72, soundId: 'small-drum', trackIndex: 0, when: 23.56105 },
  // { id: -71, soundId: 'small-drum', trackIndex: 0, when: 24.3735 },
  // { id: -70, soundId: 'small-drum', trackIndex: 0, when: 25.18595 },
  // { id: -69, soundId: 'small-drum', trackIndex: 0, when: 25.9984 },
  // { id: -68, soundId: 'small-drum', trackIndex: 0, when: 26.81085 },
  // { id: -67, soundId: 'small-drum', trackIndex: 0, when: 27.6233 },
  // { id: -66, soundId: 'small-drum', trackIndex: 0, when: 28.43575 },
  // { id: -65, soundId: 'small-drum', trackIndex: 0, when: 29.2482 },
  // { id: -64, soundId: 'small-drum', trackIndex: 0, when: 30.06065 },
  // { id: -63, soundId: 'small-drum', trackIndex: 0, when: 30.8731 },
  // { id: -62, soundId: 'small-drum', trackIndex: 0, when: 31.68555 },
]

const state: State = {
  audioContext: audioUtil.createAudioContext(),
  audioContextStartAt: 0,
  score: presetScore,
  removedScore: [],
  playingBufferSources: [],
  soundSources: {
    bgm: bgm,
    effect: effects,
    userRecorded: userRecorded,
  },
  duration: 0,  // BGMから取得する
  barDuration: 1.611,
  audioLatencyAdjust: Number(Cookies.get(settings.cookieName.audioLatencyAdjust)) || 0,  // TODO cookieから復元
  trackWidthPerSecond: 80,  // defaultはsmallサイズ
  playMode: 'play',
  isRecordMode: false,
  isPlaying: false,
  isCountingDown: false,
  currentTime: 0,
  isReady: false,
  selectedTrackIndex: 0,
}

const getters: GetterTree<State, RootState> = {
  /**
   * 音（BGM、SE）の一覧
   * @param state
   */
  [Getter.SOUND_SOURCES]: (state: State): types.SoundSrc[] => {
    return state.soundSources.bgm.concat(state.soundSources.effect).concat(state.soundSources.userRecorded)
  },

  /**
   * 再生中の音があるか
   * @param state
   */
  [Getter.HAS_PLAYING_BUFFER_SOURCE]: (state: State): boolean => {
    return state.playingBufferSources.length > 0
  },

  /**
   * 音の一覧からIDに該当するソースを取得
   * ※引数ありなのでComputedでキャッシュされない点に注意
   * @param state
   * @param getters
   */
  [Getter.SOUND_SOURCE]: (state: State, getters: any) => (soundId: string): types.SoundSrc | types.UserRecordedSoundSrc | null => {
    const find = getters[Getter.SOUND_SOURCES].filter((item: types.SoundSrc | types.UserRecordedSoundSrc) => item.soundId === soundId)
    return find ? find[0] : null
  },
}

const mutations: MutationTree<State> = {
  /**
   * AudioContextを生成
   * @param state
   */
  [Mutation.AUDIO_CONTEXT.CREATE]: (state: State) => {
    // closeしている場合だけ生成し直す
    // if (state.audioContext.state === 'closed' || state.audioContext.state === 'suspended') {
    if (state.audioContext && state.audioContext.state === 'closed') {
      state.audioContext = audioUtil.createAudioContext()
    }
  },

  /**
   * 再生開始時のAudioContextの進んでいた時間を保持
   * 差を計算して、エフェクトが何秒に置かれたか計算するため
   * @param state
   * @param startAt
   */
  [Mutation.AUDIO_CONTEXT.START_AT]: (state: State, startAt: number) => {
    state.audioContextStartAt = startAt
  },

  /**
   * 再生された音を再生リストに追加する
   * @param state
   * @param payload
   */
  [Mutation.PLAYING_BUFFER_SOURCE.ADD]: (state: State, payload: types.PlayingBufferSource) => {
    state.playingBufferSources.push(payload)
  },

  /**
   * 再生中リストから取り除く
   * @param state
   * @param playingBufferSourceId
   */
  [Mutation.PLAYING_BUFFER_SOURCE.REMOVE]: (state: State, playingBufferSourceId: number) => {
    // 配列の要素を削除しながら処理するので後ろから走査
    for (let i = state.playingBufferSources.length - 1; i >= 0; i--) {
      // 再生中の一覧から、該当するIDを削除する
      const source = state.playingBufferSources[i]
      if (source.id === playingBufferSourceId) {
        // TODO 音停止する？
        source.audioBufferSourceNode.disconnect()
        source.audioBufferSourceNode.stop()

        // 配列から削除
        state.playingBufferSources.splice(i, 1)
      }
    }
  },

  /**
   * 再生中リストをクリア（＝すべて停止）
   * @param state
   */
  [Mutation.PLAYING_BUFFER_SOURCE.CLEAR]: (state: State) => {
    // TODO 一応音停止しておく？
    for (let i = 0, l = state.playingBufferSources.length; i < l; i++) {
      state.playingBufferSources[i].audioBufferSourceNode.disconnect()
      state.playingBufferSources[i].audioBufferSourceNode.stop()
    }

    state.playingBufferSources = []
  },

  /**
   * スコアに音を配置する
   * @param state
   * @param payload
   */
  [Mutation.SCORE.ADD_SOUND]: (state: State, payload: types.SoundOnScore) => {
    state.score.push(payload)
  },

  /**
   * トラックの最後の音を削除
   * @param state
   * @param trackIndex トラックのインデックス
   */
  [Mutation.SCORE.UNDO]: (state: State, trackIndex: number) => {
    // スコア履歴から該当レイヤーの最後の操作を見つける
    let targetIndex = -1
    for (let i = state.score.length - 1; i >= 0; i--) {
      if (state.score[i].trackIndex === trackIndex) {
        targetIndex = i
        break
      }
    }

    if (targetIndex >= 0) {
      // 指定レイヤーの最後に配置された音を削除
      const removed: types.SoundOnScore[] = state.score.splice(targetIndex, 1)

      // 削除された音を削除済みのキューに追加
      state.removedScore.push(removed[0])
    }
  },

  /**
   * トラックの音を削除
   * @param state
   * @param trackIndex トラックのインデックス
   */
  [Mutation.SCORE.RESET]: (state: State, trackIndex: number) => {
    // 配列をリアクティブにするためにsplice()で一つずつ削除していく
    for (let i = state.score.length - 1; i >= 0; i--) {
      if (state.score[i].trackIndex === trackIndex) {
        state.score.splice(i, 1)
      }
    }
  },

  /**
   * （デバッグ用） トラックの音を復元
   * @param state
   */
  [Mutation.DEBUG.SCORE.RESTORE]: (state: State, score: types.SoundOnScore[]) => {
    console.log('Mutation.DEBUG.SCORE.RESTORE', Object.assign({}, score))
    state.score = score
  },

  /**
   * 取得したAudioBufferを設定する
   * @param state
   * @param payload
   * @param payload.src
   * @param payload.audioBuffer
   */
  [Mutation.SET_AUDIO_BUFFER]: (state: State, payload: { src: string; audioBuffer: AudioBuffer }) => {
    // BGMはひとまず1件の想定
    for (let i = 0, l = state.soundSources.bgm.length; i < l; i++) {
      const sound = state.soundSources.bgm[i]
      if (sound.src === payload.src) {
        sound.audioBuffer = payload.audioBuffer

        if (i === 0) {
          // 再生時間を保持
          // TODO BGMが複数になったら、この処理はBGM選択時にするようにする
          state.duration = payload.audioBuffer.duration
        }
      }
    }

    for (let i = 0, l = state.soundSources.effect.length; i < l; i++) {
      const sound = state.soundSources.effect[i]
      if (sound.src === payload.src) {
        // console.log(payload.src, payload.audioBuffer)
        sound.audioBuffer = payload.audioBuffer
      }
    }
  },

  /**
   * 音ズレの調整
   * @param state
   * @param audioLatencyAdjust
   */
  [Mutation.AUDIO_LATENCY_ADJUST]: (state: State, audioLatencyAdjust: number) => {
    state.audioLatencyAdjust = audioLatencyAdjust
  },

  /**
   * ユーザー
   * @param state
   * @param audioBuffer
   */
  [Mutation.USER_SOUND.SET]: (state: State, audioBuffer: AudioBuffer) => {
    state.soundSources.userRecorded.audioBuffer = audioBuffer
    state.soundSources.userRecorded.hasAudioBuffer = true
  },

  /**
   * 再生モードを変更する
   * @param state
   * @param mode
   */
  [Mutation.CHANGE_PLAY_MODE]: (state: State, mode: types.PlayMode) => {
    state.playMode = mode
  },

  /**
   * 再生、停止のステータスを変更
   * @param state
   * @param isPlaying 再生中か
   */
  [Mutation.CHANGE_PLAY_STATUS]: (state: State, isPlaying: boolean) => {
    state.isPlaying = isPlaying
  },

  /**
   * アクティブなトラックを変更
   * @param state
   * @param trackIndex 選択されたトラックのインデックス
   */
  [Mutation.CHANGE_ACTIVE_TRACK]: (state: State, trackIndex: types.TrackIndex) => {
    state.selectedTrackIndex = trackIndex
  },

  /**
   * 秒あたりのトラック幅を小サイズに変更
   * @param state
   */
  [Mutation.TRACK_WIDTH_PER_SECOND.SM]: (state: State) => {
    state.trackWidthPerSecond = 80
  },

  /**
   * 秒あたりのトラック幅を小サイズに変更
   * @param state
   */
  [Mutation.TRACK_WIDTH_PER_SECOND.MD]: (state: State) => {
    state.trackWidthPerSecond = 200
  },

  /**
   * 収録前のカウントダウンを開始
   * @param state
   */
  [Mutation.COUNTDOWN.START]: (state: State) => {
    state.isCountingDown = true
  },

  /**
   * 収録前のカウントダウンを停止
   * @param state
   */
  [Mutation.COUNTDOWN.STOP]: (state: State) => {
    state.isCountingDown = false
  },
}

const actions: ActionTree<State, RootState> = {
  /**
   * 音ファイルをAudioBufferに変換する
   * @param context
   * @param src 読み込むファイル
   */
  [Action.FETCH_AUDIO_FILE]: (context: ActionContext<State, RootState>, src: string) => {
    if (src) {
      axios.get(src, {
        responseType: 'arraybuffer',
      })
        .then((response: AxiosResponse<ArrayBuffer>) => {
          // ArrayBufferをAudioBufferにデコードする
          // SafariはPromiseベースのデコードをサポートしていないのでコールバックで記述する
          if (context.state.audioContext) {
            context.state.audioContext.decodeAudioData(response.data,
              (decodedData) => {
                context.commit(Mutation.SET_AUDIO_BUFFER, {
                  src,
                  audioBuffer: decodedData,
                })
              },
              (e) => {
                console.log(e, src)
              })
          }
        })
        .catch((e: Error) => {
          console.error(`fetchAudio failure! ${e}`)
        })
    } else {
      console.error('Action.FETCH_AUDIO_FILE:: src is invalid.', src)
    }
  },
}

const store: Module<State, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

export default store
